import React, { useEffect, useState } from "react";
import { getPrivacyPolicy } from "../api/privacyPolicy.api";
import BackgroundCircles from "../../../components/ui/BackgroundCircles";
import { Header } from "../../../app/layouts";
import PageContent from "../../../app/layouts/PageContent";
import { useNavigate } from "react-router-dom";

const PrivacyPolicyPage = () => {
  document.title = "Privacy Policy";

  const [content, setContent] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const res = await getPrivacyPolicy();

        if (res.success && res.data?.label === "privacy_policy") {
          setContent(res.data.value || "");
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicy();
  }, []);

  return (
    <>
      <Header />

      <PageContent>
        <div className="min-h-screen bg-[#f5f7ff] px-3 sm:px-6 lg:px-10 py-6 sm:py-8">

          <div
            className="
              relative overflow-hidden
              max-w-[1200px] mx-auto
              rounded-xl sm:rounded-2xl
              shadow-[0_10px_30px_rgba(0,0,0,0.08)]
              bg-white
              pt-12 sm:pt-16
              pb-14 sm:pb-20
            "
          >
            {/* Gradient Background */}
            <div className="absolute top-0 left-0 right-0 h-[160px] sm:h-[220px] bg-gradient-to-b from-[#e8efff] via-[#f4f7ff] to-transparent z-0" />

            {/* Background Circles */}
            <div className="absolute top-0 left-0 right-0 h-[200px] sm:h-[280px] opacity-20 sm:opacity-25">
              <BackgroundCircles />
            </div>

            <div className="relative z-10 max-w-[1100px] mx-auto px-4 sm:px-6">

              {/* HEADER */}
              <div className="mb-8 sm:mb-12">
                <h1 className="text-[24px] sm:text-[28px] lg:text-[32px] font-semibold text-[#26295e] relative inline-block">
                  Privacy Policy
                  <span className="absolute -bottom-2 sm:-bottom-3 left-0 w-10 sm:w-12 h-[3px] bg-[#7365FF]" />
                </h1>
              </div>

              {/* CONTENT */}
              {loading ? (
                <div className="flex justify-center py-8 sm:py-10">
                  <div className="animate-spin h-5 w-5 sm:h-6 sm:w-6 border-2 border-gray-300 border-t-gray-700 rounded-full" />
                </div>
              ) : (
                <>
                  <div
                    className="
                      max-w-none
                      text-[#6b7394]
                      text-[14px] sm:text-[15px]
                      leading-[24px] sm:leading-[28px]
                      space-y-5 sm:space-y-6

                      [&_p]:mb-3 sm:[&_p]:mb-4
                      [&_ul]:pl-5 sm:[&_ul]:pl-6
                      [&_li]:mb-2
                      [&_ol]:pl-5 sm:[&_ol]:pl-6

                      [&_h1]:text-[20px] sm:[&_h1]:text-[24px]
                      [&_h2]:text-[18px] sm:[&_h2]:text-[20px]
                      [&_h3]:text-[16px] sm:[&_h3]:text-[18px]

                      [&_h1,&_h2,&_h3]:text-[#26295e]
                      [&_h1,&_h2,&_h3]:font-semibold
                      [&_h1,&_h2,&_h3]:mt-5 sm:mt-6
                    "
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  />

                  {/* FOOTER BUTTON */}
                  <div className="mt-10 sm:mt-12">
                    <button
                      onClick={() => navigate("/login")}
                      className="
                        w-full sm:w-auto
                        bg-[#3b519c]
                        hover:bg-[#2f407c]
                        text-white
                        px-6 py-3 sm:py-2
                        rounded-lg
                        shadow
                        text-sm
                      "
                    >
                      I Understand
                    </button>
                  </div>
                </>
              )}

            </div>
          </div>

        </div>
      </PageContent>
    </>
  );
};

export default PrivacyPolicyPage;